module.exports = {
  states: {
    studentId: '' || window.localStorage.getItem('studentId')
  },
  mutations: {
    setStudentId (state, id) {
      console.log('studentid', id)
      state.studentId = id
      window.localStorage.setItem('studentId', id)
    },
    removeStudentId (state) {
      state.studentId = ''
      window.localStorage.removeItem('studentId')
    }
  },
  actions: {},
  getters: {},
  namespaced: true
}
